module.exports = __webpack_public_path__ + "d7ef6919d755daf56c141baa9642a27c.MP3";